import React, { useState, useCallback } from "react";
import ViewProfileLayerAdmin from "./ViewProfileLayerAdmin";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";

const ViewProfilePageAdmin = () => {
  const [switchToEditSignal, setSwitchToEditSignal] = useState(0);
  const requestEditProfile = useCallback(() => {
    setSwitchToEditSignal((n) => n + 1);
  }, []);

  return (
    <>
      <MasterLayout>
        <Breadcrumb
          title="View Profile"
          // extra={
          //   <button
          //     type="button"
          //     className="btn btn-primary-600 radius-8 px-20 py-10 text-sm fw-medium"
          //     onClick={requestEditProfile}
          //   >
          //     Update profile
          //   </button>
          // }
        />
        <ViewProfileLayerAdmin switchToEditSignal={switchToEditSignal} />
      </MasterLayout>
    </>
  );
};

export default ViewProfilePageAdmin;
